import BannerComp from "../components/BannerComp";
import Counter from "../components/Counter";
import Faqs from "../components/Faqs";
import FeatureCard from "../components/FeatureCard";
import FeatureFlow from "../components/FeatureFlow";
import FeatureImageContent from "../components/FeatureImageContent";
import ProPrograms from "../components/ProPrograms";
import ServiceCardsGrid from "../components/ServiceCardsGrid";
import Seo from "../components/Seo";
import Testimonials from "../components/Testimonials";
import { faqs } from "../data/faqs";
import {
  counterData,
  featuresCardData,
  proPrograms,
  stepper,
} from "../data/home";
import { serviceCards } from "../data/services";
import { testimonials } from "../data/testimonials";
import { createWebPageSchema } from "../lib/seo";
import Section1 from "./Sections/Section1";
import Section2 from "./Sections/Section2";
import Section3 from "./Sections/Section3";
import Section4 from "./Sections/Section4";

const seo = {
  title: "MIT4Doctors | Healthcare Solutions & Technology",
  description:
    "MIT4Doctors provides innovative healthcare solutions, medical technology services, and advanced programs that improve patient care and support providers.",
  schema: [
    createWebPageSchema({
      path: "/",
      title: "MIT4Doctors",
      description:
        "MIT4Doctors provides innovative healthcare solutions, medical technology services, and advanced programs designed to improve patient care and support healthcare providers.",
    }),
  ],
};

export default function Home() {
  return (
    <>
      <Seo
        title={seo.title}
        metaTitle={seo.title}
        description={seo.description}
        canonicalPath="/"
        schema={seo.schema}
      />
      <BannerComp
        hero
        heroVariant="dark"
        heroBadge="MODERN HEALTHCARE RCM"
        heading={"Innovating Healthcare\nTransforming Lives"}
        paragraph="A modern healthcare platform focused on accessible neurofeedback, patient care, and meaningful business growth."
        btnText="Get a Free Practice Audit"
        btnLink="/contact-us"
        secondaryBtnText="Schedule a Consultation"
        secondaryBtnLink="/contact-us"
        heroChips={["HIPAA Ready", "Insurance Friendly", "Patient Focused"]}
      />
      <Section1 />
      <Section2 />
      <ServiceCardsGrid
        sectionTitle="Our Core Services"
        sectionDescription="Explore the main offerings MITSI brings to providers who want a cleaner workflow, stronger support, and a more modern patient experience."
        highlightText="Services"
        cards={serviceCards}
      />
      <FeatureImageContent
        eyebrow="Redefining Patient Care With"
        heading="Smarter Solutions for Better Care"
        description="We're redefining patient care with cutting-edge solutions. We help practices improve outcomes and efficiency. Our services include neurofeedback, wound care, lab tests, and advanced diagnostics."
        buttonLabel="Get Started"
        buttonUrl="/contact-us"
        imageAlt="Smarter Solutions for Better Care"
      />
      <ProPrograms
        heading="Let's talk about our"
        highlightText="Pro Programs"
        description="Our Pro Programs enhance patient care and practice success by providing innovative solutions without any upfront costs, addressing ADHD, PTSD, autism, and seniors' memory care."
        programs={proPrograms}
      />
      <FeatureCard
        sectionTitle="How we help all types of Providers"
        sectionDescription="From primary care practices to specialty clinics and large healthcare facilities, we provide practical solutions that improve workflows, support clinical teams, and help deliver better patient care."
        highlightText="Providers"
        features={featuresCardData}
      />
      <Section3 />
      <FeatureFlow
        heading="Allergy Testing & Immunotherapy Benefits"
        highlights={["Testing", "Immunotherapy"]}
        paragraph="No upfront costs! You pay a simple monthly fee, and major insurance plans cover most of it."
        steps={stepper}
      />
      <Section4 />
      <Counter data={counterData} />
      <Testimonials testimonials={testimonials} />
      <Faqs faqs={faqs} />
    </>
  );
}
